// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  messageId: __t.u64(),
  fileName: __t.string(),
  fileType: __t.string(),
  fileSize: __t.u64(),
  fileUrl: __t.string(),
  thumbnailUrl: __t.option(__t.string()),
};
